import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { ReportState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: ReportState = getDefaultState();

const namespaced: boolean = true;

export const reports: Module<ReportState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
